export default __webpack_public_path__ + "static/media/ico_11.510fd68a.png";